import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { CustomAccordion, Text } from '../../shared/uiComponents';
import { InfoRow as Row } from '../StyledComponents';

import { DispatchProperties, useSelector } from '../../redux/store';
import { getUserInsurances } from '../../redux/State/userSlice';

const InsuranceList = ({ id }: { id: string }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const userInsurances = useSelector((state) => state.insuranceUser.userInsurances);

	useEffect(() => {
		if (!id) return;
		dispatch(getUserInsurances(id));
	}, [id, dispatch]);

	return userInsurances.length ? (
		<CustomAccordion
			headerStyle={{ padding: 0 }}
			HeaderContent={() => (
				<Row>
					<Text title="Insurances: " type="psm" fontWeight="semiBold" />
					<Text title={`${userInsurances.length}`} />
				</Row>
			)}
			Content={() => (
				<div style={{ padding: '0px 8px' }}>
					{userInsurances.map((insurance, index) => (
						<Text type="psm" title={`${index + 1}. ${insurance.name}`} className="marginRight8" key={insurance.name} />
					))}
				</div>
			)}
		/>
	) : null;
};

export default InsuranceList;
